export const columnsDataDevelopment = [
  {
    Header: "ÉQUIPE A",
    accessor: "Équipe A",
  },
  {
    Header: "ÉQUIPE B",
    accessor: "Équipe B",
  },
  {
    Header: "ÉQUIPE C",
    accessor: "Équipe C",
  },
  {
    Header: "MARKETING & EXPORT",
    accessor: "MARKETING & EXPORT",
  },
  {
    Header: "SUPERVISEURS",
    accessor: "SUPERVISEURS",
  },
 
];

export const columnsDataCheck = [
  {
    Header: "name",
    accessor: "name",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
  {
    Header: "QUANTITY",
    accessor: "quantity",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
];

export const columnsDataColumns = [
  {
    Header: "name",
    accessor: "name",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
  {
    Header: "QUANTITY",
    accessor: "quantity",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
];

export const columnsDataComplex = [
  
  {
    Header: "Rang",
    accessor: "rang",
  },
  {
    Header: "Scénario",
    accessor: "scénario",
  },
  {
    Header: "Mesure",
    accessor: "score",
  },
];
